/** One card of the mocked corp surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, ROWS, heading, subtle } from './corp-mock';

export function PayoutsCard() {
  return (
    <section className="nb-card" style={{ flex: 1, minHeight: 0 }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={heading}>
          Upcoming Payouts
        </h3>
        <span className="nb-eyebrow">{EM_DASH} scheduled</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {ROWS.map((r) => (
          <div
            key={r}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '8px 10px',
              background: 'var(--nb-surface)',
              borderRadius: 8,
              border: '1px solid var(--nb-border)',
            }}
          >
            <div
              style={{
                width: 40,
                flex: '0 0 40px',
                textAlign: 'center',
                padding: '4px 0',
                background: 'var(--nb-cream)',
                color: 'var(--nb-forest)',
                borderRadius: 6,
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              {EM_DASH}
            </div>
            <div style={{ flex: 1, minWidth: 0, color: subtle, fontSize: 12.5, fontWeight: 700 }}>
              {EM_DASH}
            </div>
            <span
              className="nb-tabular nb-mono"
              style={{ fontSize: 14, fontWeight: 700, color: subtle }}
            >
              {EM_DASH}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
